// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import apiClient from './client';
import type { ProviderConfig } from '../types';

export interface BrandingConfig {
  logoUrl: string | null;
  primaryColor: string | null;
  displayName: string | null;
}

export const getProviderConfig = (): Promise<ProviderConfig> =>
  apiClient.get<ProviderConfig>('/api/config/provider').then((r) => r.data);

export const getBranding = (providerCode?: string): Promise<BrandingConfig> => {
  const params = providerCode ? `?providerCode=${encodeURIComponent(providerCode)}` : '';
  return apiClient.get<BrandingConfig>(`/api/config/branding${params}`).then((r) => r.data);
};
